var map = {
	"./Armada To Esquiva.fbx": "bef9",
	"./Armada.fbx": "ed8f",
	"./Bencao.fbx": "d895",
	"./Chapa 2.fbx": "7c12",
	"./Chapa Giratoria 2.fbx": "1110",
	"./Chapa-Giratoria.fbx": "d96f",
	"./Chapaeu De Couro.fbx": "0902",
	"./Martelo 2.fbx": "b935",
	"./Martelo 3.fbx": "e7e2",
	"./Martelo Do Chau.fbx": "17c3",
	"./Meia Lua De Compasso Back.fbx": "de42",
	"./Meia Lua De Frente.fbx": "4033",
	"./au to role.fbx": "9e42",
	"./au.fbx": "655e",
	"./capoeira (2).fbx": "5320",
	"./capoeira (3).fbx": "2f6f",
	"./capoeira.fbx": "9186",
	"./esquiva 1.fbx": "25d5",
	"./esquiva 2.fbx": "1783",
	"./esquiva 3.fbx": "c916",
	"./esquiva 4.fbx": "3217",
	"./esquiva 5.fbx": "07a3",
	"./ginga backward.fbx": "4d49",
	"./ginga forward.fbx": "2747",
	"./ginga sideways 1.fbx": "4d39",
	"./ginga sideways 2.fbx": "b125",
	"./ginga sideways to au.fbx": "4e69",
	"./ginga variation 1.fbx": "753c",
	"./ginga variation 2.fbx": "48a2",
	"./ginga variation 3.fbx": "484a",
	"./macaco side.fbx": "baff",
	"./martelo do chau sem mao.fbx": "9552",
	"./meia lua de compasso.fbx": "1c71",
	"./pontera.fbx": "01a1",
	"./queshada 1.fbx": "603f",
	"./queshada 2.fbx": "9bbe",
	"./rasteira 1.fbx": "1f28",
	"./rasteira 2.fbx": "3473",
	"./troca 1.fbx": "54a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d962";